import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

/** contact-thanks */
export default class extends Controller {
  connect() {
    const url = new URL(location.href);

    // パラメーター付きで来たものは何もしない
    if (url.searchParams.has("iframe")) return;

    const iframe = window !== window.parent;
    url.searchParams.set("iframe", iframe.toString());

    if (iframe) {
      // formrunのリダイレクト先は layout: naked なのでそのまま Turbo.visit
      Turbo.visit(url, { action: "replace" });
    } else {
      // true以外はレイアウトが違ったりするので全体をロード
      location.href = url;
    }
  }
}
